import React, {Component} from 'react';
import {getPreviousReportsOfProperty} from "../../data/report_api";
import {Form, Button} from 'semantic-ui-react';
import moment from "moment";
import ReportContainer from "../../containers/report_container";
import {getCustomReportDetails} from "../../data/custom_report_upload_api";
import { handleFileDownload } from "../../utils/download_file";
import { BASE_URL } from "../../constants/app_routes";
import DownloadingIntent from "../universal/toast";

class DownloadPreviousReports extends Component {

    constructor(props){
        super(props);
        this.state = {
            reportListOptions:[],
            selectedInspection: undefined,
            showDownload: false,
            isDownloading: false,
        }
    }

    componentWillMount() {
        const inspectionStatus = {"pending":'Pending', "scheduled":'Scheduled', "confirmed":'Confirmed', "processing":'Processing', "submitted":'Submitted', "completed":'Completed', "request_abort":'Requested Abort', "aborted":'Aborted', "request_cancel":'Request Cancel', "cancelled":'Cancelled'};
        getPreviousReportsOfProperty(this.props.reportId,this.props.inspectionType,"true").then((reportList_)=>{
            let reportList = reportList_.inspections
            let reportOptions = [{key:'00',text:'---Select Report---',value:undefined}];
            const listOptions = reportList.length;
            if(listOptions > 0){
                for (let i = 0; i < listOptions; i++) {
                    let obj = {
                        key: reportList[i]['id'],
                        text: reportList[i]['inspection_type'].toUpperCase() +" - " + moment(reportList[i]['inspection_start_time'],"YYYY-MM-DD HH:mm:ss Z").format("LL") +" - "+inspectionStatus[reportList[i]['status']],
                        value: i,
                        custom:reportList[i]['custom_report_id'],
                        report:reportList[i]['report_id']
                                        };
                    reportOptions.push(obj);
                }
                this.setState({reportListOptions: reportOptions});
            }
        })
    }

    handleDownload = async (reportId) => {
        if(!this.state.isDownloading) {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/report/download/"+reportId;
        const fileName = this.props.reportDetails['filename'];
        await handleFileDownload(URL,fileName);
        this.setState({isDownloading:false});
        }
    };

    handleReport = () => {
        const reportDetail = this.state.reportListOptions[this.state.selectedInspection]
        if (reportDetail['custom']) {
            getCustomReportDetails(reportDetail['custom']).then((response) => {if (response['custom_report']){ Object.assign(document.createElement('a'), { target: '_blank', href: response['custom_report']['file']}).click();}})
        }
        else {
            if (reportDetail['report']) {
                this.handleDownload(reportDetail["report"])
            }
            else 
            {
                return undefined;
            }
        }
    };

    render(){
        return(<div style={{width:'50%'}}>
                <Form>
             <Form.Dropdown
                label='Download Previous Reports'
                required
                selection
                search
                noResultsMessage="No previous reports found"
                wrapSelection={false}
                options={this.state.reportListOptions}
                placeholder='Select Report to Load'
                onChange={(e, option) => {this.setState({selectedInspection:option.value + 1 })}}
            />
                <Button type="button" content="Cancel" onClick={()=>{this.props.close()}}/>
                <Button content="Download Report PDF" onClick={() =>  {this.handleReport()}} primary disabled={!this.state.selectedInspection} as="a" target="_blank" />
            </Form>
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
                </div>)
    }
}

export default ReportContainer(DownloadPreviousReports);


// WEBPACK FOOTER //
// ./src/views/report/download_previous_reports.js